import React, { useMemo } from 'react'

// material ui
import Tooltip from '@mui/material/Tooltip'

// hooks
import useVariantsByComponentIdQuery from '../../../hooks/components/useVariantsByComponentIdQuery'
//components
import ZeroWidthSpace from '../../PushNotificationEditor/Editor/components/ZeroWidthSpace'
import styled from 'styled-components'

// constants
import aampeTheme from '../../../constants/aampeTheme'

import useComponentTypesQuery from '../../../hooks/component-types/useComponentTypesQuery'

const VariantElement = ({ element, selectedComponent, handleSelection }) => {
    const isSelected = selectedComponent?.elementId === element.id

    const { data: componentTypes } = useComponentTypesQuery()

    const componentTypeData = componentTypes?.map?.[element.variantType]

    const variantDetails = {
        kind: 'variant',
        variantType: element.variantType,
        elementId: element.id,
    }
    const { data = [], isLoading } = useVariantsByComponentIdQuery(element.id)

    const displayText = useMemo(() => {
        if (!isLoading && data.length) {
            return data[0].content
        }
        return '[Component]'
    }, [data, isLoading, element])

    return (
        <Tooltip title={`${componentTypeData?.name}`}>
            <Element
                onClick={() => {
                    isSelected
                        ? handleSelection(null)
                        : handleSelection(variantDetails)
                }}
                isSelected={isSelected}
                color={componentTypeData?.base_color}
            >
                <ZeroWidthSpace />
                {displayText}
            </Element>
        </Tooltip>
    )
}

const Element = styled.span`
    display: inline-block;
    cursor: pointer;
    background-color: ${({ isSelected, color }) =>
        isSelected ? color : 'transparent'};
    color: ${({ isSelected, color }) =>
        isSelected ? aampeTheme.colors.white : color};
    padding: ${aampeTheme.spacing(0, 0.5)};
    border-radius: ${aampeTheme.borderRadius.default};
`

export default VariantElement
